module.exports = __webpack_public_path__ + "img/qilin-f-stage4-sulking.f2650919.png";